import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const linkClass = 'tiu-navlink';

  return (
    <nav className="tiu-nav">
      <div className="mx-auto max-w-6xl px-4 h-20 flex items-center justify-between gap-4">
        {/* Logo */}
        <Link to="/" className="flex items-center flex-shrink-0" aria-label="Tee It Up home">
          <img src="/assets/Logo1.png" alt="Tee It Up" className="h-16 sm:h-[72px] w-auto" />
        </Link>

        {/* Desktop nav */}
        <div className="hidden sm:flex items-center gap-1">
          <Link to="/" className={linkClass}>Search</Link>
          {currentUser && <Link to="/profile" className={linkClass}>Profile</Link>}
          <Link to="/alerts" className={linkClass}>Alerts</Link>
        </div>

        <div className="hidden sm:flex items-center gap-2 flex-shrink-0">
          {currentUser ? (
            <button onClick={handleLogout} className="tiu-btn tiu-btn-quiet">Log out</button>
          ) : (
            <>
              <Link to="/login" className="tiu-btn tiu-btn-quiet">Log in</Link>
              <Link to="/signup" className="tiu-btn tiu-btn-primary">Get started</Link>
            </>
          )}
        </div>

        {/* Mobile toggle */}
        <button
          className="sm:hidden p-2 -mr-2 text-slate-700"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label="Toggle menu"
        >
          <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-40 z-30 sm:hidden" onClick={() => setMenuOpen(false)} />
          <div className="sm:hidden absolute left-0 right-0 top-20 z-40 tiu-mobile-menu">
            <div className="px-4 py-3 flex flex-col gap-1">
              <Link to="/" className={linkClass} onClick={() => setMenuOpen(false)}>Search</Link>
              {currentUser && (
                <Link to="/profile" className={linkClass} onClick={() => setMenuOpen(false)}>Profile</Link>
              )}
              <Link to="/alerts" className={linkClass} onClick={() => setMenuOpen(false)}>
                Alerts
              </Link>
              <div className="h-px bg-slate-200 my-2" />
              {currentUser ? (
                <button
                  onClick={() => { handleLogout(); setMenuOpen(false); }}
                  className="tiu-btn tiu-btn-secondary w-full"
                >
                  Log out
                </button>
              ) : (
                <div className="flex flex-col gap-2">
                  <Link to="/login" className="tiu-btn tiu-btn-secondary w-full" onClick={() => setMenuOpen(false)}>
                    Log in
                  </Link>
                  <Link to="/signup" className="tiu-btn tiu-btn-primary w-full" onClick={() => setMenuOpen(false)}>
                    Get started
                  </Link>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </nav>
  );
};

export default Navbar; 